import { inject, InjectionToken } from '@angular/core';
import { RuntimeConfig } from './runtime-config.model';

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG');

export function injectRuntimeConfig(): RuntimeConfig {
  return inject(RUNTIME_CONFIG);
}
